const getDifferenceInTwoDates = (startDate: Date, endDate: Date): number => {
  return new Date(startDate).getTime() - new Date(endDate).getTime();
};
export default getDifferenceInTwoDates;
